import React, {Component} from 'react';
import firebase from '../../firebase.js';

export default class IncomingItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cancelModalOpen: false
        }
    }

    acceptOrder() {
        let path = 'Hotels/orders/' + this.props.hotelId + '/' + this.props.order.order_id;
        firebase.database().ref(path).update({
            completed: true,
            status: 'accepted'
        });
        let bodyText = 'Order ' + this.props.order.order_id + ' is ready to be collected';
        fetch('https://exp.host/--/api/v2/push/send', {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            to: this.props.order.notification_token,
            text:"Your order is ready!",
            body: bodyText
          })
        }).then((response) => {
            //send it all ok
        }).catch((error) => {
            console.log('error: ' + error)
        })
    }
    cancelOrder() {
        this.closeCancelModal();
        let path = 'Hotels/orders/' + this.props.hotelId + '/' + this.props.order.order_id;
        firebase.database().ref(path).update({
            completed: true,
            status: 'cancelled'
        });

        let bodyText = 'Order ' + this.props.order.order_id + ' has been cancelled';

        fetch('https://exp.host/--/api/v2/push/send', {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            to: this.props.order.notification_token,
            text:"Your order has been cancelled.",
            body: bodyText
          })
        }).then((response) => {
            //send it all ok
        }).catch((error) => {
            console.log('error: ' + error)
        })
    }

    openCancelModal(){
        this.setState({
            cancelModalOpen: true
        })
    }
    closeCancelModal() {
        this.setState({
            cancelModalOpen: false
        })
    }

    render() {
        let rowStyle = {width: '90%'};
        console.log(this.props.order);
        return (
            <div>
                <div className="heading-bar">
                    <div style={rowStyle} className="row">
                        <div className="desktop-12 tablet-6 mobile-3">
                            <ul>
                                <li className="name">{this.props.order.user_email}</li>
                                <li className="status-incoming">Status: {this.props.order.status}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="order-body">
                    <div style={rowStyle} className="row">
                        <div className="desktop-6 tablet-6 mobile-3 order-items">
                            <ul>
                            {this.props.order.order.map((orderItem, index) =>
                                (<li key={index}>
                                    {orderItem.count} x {orderItem.dish_name}
                                </li> ))}
                            </ul>

                        </div>
                    <div className="desktop-6 tablet-6 mobile-3">
                            <ul className="total">
                                <li>Total<br/><span>NOK {this.props.order.totalProductsPrice},-</span></li>
                                <li>Order no<br/><span>{this.props.order.receipt_number}</span></li>
                            </ul>
                            <div className="action-holder">
                                <ul>
                                    <li onClick={this.acceptOrder.bind(this)}>Order Ready</li>
                                    <li onClick={this.openCancelModal.bind(this)}>Cancel</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.cancelModalOpen ? (
                <div className="co-modal">
                    <div className="co-modal-internal row">
                        <div className="desktop-12 tablet-6 mobile-3">
                            <span onClick={this.closeCancelModal.bind(this)} className="co-toggle-x">X</span>
                            <p>Are you sure you want to cancel order {this.props.order.order_id}.</p>
                            <div className="co-buttons-cont">
                                <p onClick={this.closeCancelModal.bind(this)} className="co-ghost">No Thanks</p>
                                <p onClick={this.cancelOrder.bind(this)} className="co-full">Cancel Order</p>
                            </div>
                        </div>
                    </div>
                </div>
                    ) : ('')}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard/IncomingItem.js